import React, { useEffect, useState, useRef, useMemo } from "react";
import report from "../reports";
import Stack from "react-bootstrap/Stack";
import styled from "styled-components";
import {
  Button,
  Modal,
  Badge,
  Space,
  Row,
  Card,
  Col,
  Select,
  Form,
  DatePicker,
  message,
  Radio,
  Spin,
} from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import FilterIcon from "../../../assets/images/Filter-Icon.svg";
import ExportIcon from "../../../assets/images/Export-Icon.svg";
import {
  TotalConsignment,
  Vehiclechart,
  VerticalChart,
  VRvehiclePerformance,
  VehicleMileage,
} from "./Vehiclechart";
import { useSelector } from "react-redux";
import { ButtonFilled } from "../../../Reusablecomponents/UIButtons";
import dayjs from "dayjs";
import { CALL_API } from "../../../Common/api";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";
import ReusablePagination from "../../../Reusablecomponents/ReusablePagination";
import { StyledTable } from "../../../Reusablecomponents/UITable/UITable";
import { CSVLink } from "react-csv";
import { render } from "@testing-library/react";

const { Option } = Select;
const { RangePicker } = DatePicker;

const StyledVehicleReport = styled.div`
  .vehicle-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
  }
  .text-content
  {
 
    line-height=1.8;
    text-align:center;
  }
  .vr 
  {
  width: 1px;
  height: 100%;
  background-color: #000;
  margin-left: 120px;
}
  .donut-Needle-chart{
  display:flex;
  align-item:center;
  justify-content:center;
  }
.header {
  display: flex;
  align-items: center;
  width: 100%;
}
.export {
  margin-left: auto;
  display: flex;
  align-items: center;
}

`;

const Vehiclereport = () => {
  const [form] = Form.useForm();
  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [formValues, setFormValues] = useState({});
  const [duration, setDuration] = useState("current_month");
  const [chartData, setChartData] = useState({});
  const [chartCount, setChartCount] = useState({});
  const [selectChange, setSelectChange] = useState("No Sorting");
  const [vehiclePerformanceSelectChange, setVehiclePerformanceSelectChange] =
    useState("No Sorting");
  const [loading, setLoading] = useState(false);
  const [countLoading, setCountLoading] = useState(false);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef();
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage1, setCurrentPage1] = useState(1);

  const [PageSize, setPageSize] = useState(10);
  const [TableData, setTableData] = useState([]);
  //pagination function
  const handlePageChange = (page, PageSize) => {
    setCurrentPage1(page);
    setPageSize(PageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage1(1);
  };
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("VRPT", "EX"),
    [reduxPermissions],
  );
  const showModal = () => {
    setIsModalOpen(true);
  };

  const getSortedConsignments = () => {
    let data = chartData?.TotalConsignmentChart || [];

    if (selectChange === "Low to High") {
      data = [...data].sort((a, b) => a.ConsignmentCount - b.ConsignmentCount);
    } else if (selectChange === "High to Low") {
      data = [...data].sort((a, b) => b.ConsignmentCount - a.ConsignmentCount);
    }

    return data.slice(
      consignmentPage * itemsPerPage,
      (consignmentPage + 1) * itemsPerPage,
    );
  };

  const handleConsignmentSelectChange = (value) => {
    setSelectChange(value);
    setConsignmentPage(0); // Reset to first page on sort change
  };

  const handleConsignmentNext = () => {
    const total = chartData?.TotalConsignmentChart?.length || 0;
    if ((consignmentPage + 1) * itemsPerPage < total) {
      setConsignmentPage(consignmentPage + 1);
    }
  };

  const handleConsignmentPrev = () => {
    if (consignmentPage > 0) {
      setConsignmentPage(consignmentPage - 1);
    }
  };

  const getVehicleChart = async (overrideValues) => {
    setLoading(true);
    const values = overrideValues || formValues; // use override if provided

    const { data } = await CALL_API(
      "POST",
      `vehicle/chart?MCID=${userInfo?.MCID}&startDate=${dayjs(
        selectedDate?.[0],
      ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate?.[1]).format(
        "YYYY-MM-DD",
      )}`,
      {
        ReportType: values?.ReportType || 0,
        vehId: values?.vehicle || 0,
        Cust: values?.consignor || 0,
        Shipper: values?.transporter || 0,
        Receiver: values?.consignee || 0,
        Triptype: values?.tripType || 0,
        Driver: values?.driver || 0,
        type: values?.type || "",
        SelectedOption: values?.SelectedOption || "Vehicle",
      },
    );

    setChartData(data);
    setLoading(false);
  };

  const getVehicleCount = async () => {
    setCountLoading(true);
    const { data } = await CALL_API(
      "POST",
      `vehicle?MCID=${userInfo?.MCID}&startDate=${dayjs(
        selectedDate?.[0],
      ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate?.[1]).format(
        "YYYY-MM-DD",
      )}`,
      {
        ReportType: formValues?.ReportType || 0,
        vehId: formValues?.vehicle || 0,
        Cust: formValues?.consignor || 0,
        Shipper: formValues?.transporter || 0,
        Receiver: formValues?.consignee || 0,
        Triptype: formValues?.tripType || 0,
        Driver: formValues?.driver || 0,
        type: formValues?.type || "",
        SelectedOption: formValues?.SelectedOption || "Vehicle",
        page: currentPage1,
        pageSize: PageSize,
      },
    );
    setChartCount(data);
    setTableData(data?.vehicleTable);
    setTotal(data?.totalRecords || 0);
    setCountLoading(false);
  };

  const VehicleDetailsData = [
    {
      id: "1",
      Name: "Total No Of Vehicles",
      values: chartCount?.totalVehicle?.[0]?.Total || 0,
      precentage_values: "",
    },
    {
      id: "2",
      Name: "Active Vehicles",
      values: chartCount?.active?.[0]?.ActiveCount || 0,
      precentage_values: "",
    },
    {
      id: "3",
      Name: "Inactive Vehicles",
      values: chartCount?.inactive?.[0]?.InActiveCount || 0,
      precentage_values: "",
    },
  ];

  const getFilterCount = () => {
    const value = form.getFieldsValue() || {};
    const count = Object.values(formValues).filter(
      (val) => val && val.length !== 0,
    ).length;

    setFilterCount(count);
  };
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const ConsignmentselectChange = (value) => {
    setSelectChange(value);
  };
  const [consignmentPage, setConsignmentPage] = useState(0);
  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  useEffect(() => {
    getVehicleChart();
    getFilterCount();
  }, [formValues, selectedDate]);

  useEffect(() => {
    getVehicleCount();
  }, [formValues, selectedDate, PageSize, currentPage1]);

  const pageSize = 10;

  const getPaginatedData = () => {
    const startIndex = currentPage * pageSize;
    return chartData?.Mileage?.slice(startIndex, startIndex + pageSize) || [];
  };

  const handlePrevPage = () => {
    if (currentPage > 0) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    const maxPage = Math.floor((chartData?.Mileage?.length || 0) / pageSize);
    if (currentPage < maxPage) setCurrentPage(currentPage + 1);
  };

  const itemsPerPage = 10;

  const paginatedData = chartData?.VehiclePerformance?.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage,
  );

  const handleNext = () => {
    if (
      (currentPage + 1) * itemsPerPage <
      chartData?.VehiclePerformance?.length
    ) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };
  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle numeric fields
      if (
        [
          "Number of Trips Done",
          "Number of Consignments",
          "Total Distance Covered",
        ].includes(tableSort.field)
      ) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };
  const columns1 = [
    {
      title: "Vehicle Reg",
      dataIndex: "Vehicle Reg",
      key: "Vehicle Reg",
      sorter: (a, b) =>
        (a["Vehicle Reg"] || "").localeCompare(b["Vehicle Reg"] || ""),
      sortOrder: tableSort.field === "Vehicle Reg" ? tableSort.order : null,
    },
    {
      title: "Driver Name",
      dataIndex: "Driver Name",
      key: "Driver Name",
      sorter: (a, b) => {
        const nameA =
          driverList?.find((d) => d?.UID === a["Driver Name"])?.FULLNM || "";
        const nameB =
          driverList?.find((d) => d?.UID === b["Driver Name"])?.FULLNM || "";
        return nameA.localeCompare(nameB);
      },
      sortOrder: tableSort.field === "Driver Name" ? tableSort.order : null,
      render: (value) =>
        driverList?.find((d) => d?.UID === value)?.FULLNM || "-",
    },
    {
      title: "Number of Trips Done",
      dataIndex: "Number of Trips Done",
      key: "Number of Trips Done",
      sorter: (a, b) =>
        (a["Number of Trips Done"] || "") - (b["Number of Trips Done"] || ""),
      sortOrder:
        tableSort.field === "Number of Trips Done" ? tableSort.order : null,
    },
    {
      title: "Number of Consignments",
      dataIndex: "Number of Consignments",
      key: "Number of Consignments",
      sorter: (a, b) =>
        (a["Number of Consignments"] || "") -
        (b["Number of Consignments"] || ""),
      sortOrder:
        tableSort.field === "Number of Consignments" ? tableSort.order : null,
    },
    {
      title: "Total Distance Covered",
      dataIndex: "Total Distance Covered",
      key: "Total Distance Covered",
      sorter: (a, b) =>
        (a["Total Distance Covered"] || "") -
        (b["Total Distance Covered"] || ""),
      sortOrder:
        tableSort.field === "Total Distance Covered" ? tableSort.order : null,
    },
  ];
  const driverMap = driverList?.reduce((acc, d) => {
    acc[d.UID] = d.FULLNM;
    return acc;
  }, {});
  //  export functionality for carboonFootprint report tabel
  const prepareCSV = async (event, done) => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API(
        "POST",
        `vehicle?MCID=${userInfo?.MCID}&startDate=${dayjs(
          selectedDate?.[0],
        ).format("YYYY-MM-DD")}&endDate=${dayjs(selectedDate?.[1]).format(
          "YYYY-MM-DD",
        )}`,
        {
          ReportType: formValues?.ReportType || 0,
          vehId: formValues?.vehicle || 0,
          Cust: formValues?.consignor || 0,
          Shipper: formValues?.transporter || 0,
          Receiver: formValues?.consignee || 0,
          Triptype: formValues?.tripType || 0,
          Driver: formValues?.driver || 0,
          type: formValues?.type || "",
          SelectedOption: formValues?.SelectedOption || "Vehicle",
          page: 1,
          pageSize: total,
        },
      );
      if (data?.totalRecords > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting(data.vehicleTable || []);

        const csvData = (sortedData || []).map((item) => ({
          "Vehicle Reg": item["Vehicle Reg"] || "-",
          "Driver Name": driverMap?.[item["Driver Name"]] || "-",
          "Number of Trips Done": item["Number of Trips Done"] || "-",
          "Number of Consignments": item["Number of Consignments"] || "-",
          "Total Distance Covered": item["Total Distance Covered"] || "-",
        }));

        setCSVList(csvData && csvData.length > 0 ? csvData : []);

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
      message.error(
        "Failed to prepare CSV. " + (error?.response?.data?.message || ""),
      );
    } finally {
      setCSVLoader(false);
    }
  };

  return (
    <>
      <StyledVehicleReport>
        <Row>
          <Col span={24}>
            <Card bordered={false}>
              <div style={report.firstcontan}>
                <div style={report.overview}>
                  <span>Chart view</span>
                </div>

                <div style={report.controls}>
                  <div style={report.subcontainer}>
                    <Select
                      style={{ width: "240px" }}
                      defaultValue={duration}
                      onChange={(values) => {
                        setDuration(values);
                      }}
                    >
                      {Duration.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item?.label}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  <div style={report.subcontainer}>
                    <RangePicker
                      value={selectedDate}
                      onChange={(date, dateString) => setSelectedDate(date)}
                    />
                  </div>

                  <div style={report.subcontainer}>
                    <Button style={report.filterbtn} onClick={showModal}>
                      <Space size="middle">
                        <Badge count={filterCount}>
                          <img
                            src={FilterIcon}
                            alt="Filter Icon"
                            width={20}
                          />{" "}
                        </Badge>
                      </Space>
                    </Button>
                  </div>
                  <Modal
                    open={isModalOpen}
                    onCancel={handleCancel}
                    width={900}
                    footer={
                      <ButtonFilled
                        onClick={() => {
                          form.resetFields();
                          setFormValues({});
                        }}
                      >
                        {" "}
                        Clear All{" "}
                      </ButtonFilled>
                    }
                  >
                    <Row>
                      <Col xl={24} xs={{ span: 24, order: 2 }}>
                        <div className="container_for_kpi_filter">
                          <h6 className="Filter_for_clickablerow">
                            Filter ({filterCount})
                          </h6>
                          {/* <p className="Filter_for_Result">4 Result Found </p> */}
                        </div>
                      </Col>
                    </Row>
                    <Form
                      form={form}
                      layout="vertical"
                      onValuesChange={(value, allvalues) => {
                        getFilterCount();
                        setFormValues(allvalues);
                      }}
                    >
                      <Row gutter={16}>
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Report Type" name="ReportType">
                            <Select
                              className="w-100"
                              showSearch
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            >
                              <Option value={0}>Consignment</Option>
                              <Option value={1}>Trip</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Vehicle" name="vehicle">
                            <Select
                              className="w-100"
                              showSearch
                              optionFilterProp="children"
                              options={vehicleList?.map((item) => ({
                                label: item.REGNO,
                                value: item.VEHID,
                              }))}
                              filterOption={(input, option) =>
                                option?.label
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Consignor" name="consignor">
                            <Select
                              className="w-100"
                              showSearch
                              optionFilterProp="children"
                              options={consignerList?.map((item) => ({
                                label: item.Name,
                                value: item.ID,
                              }))}
                              filterOption={(input, option) =>
                                option?.label
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Transporter" name="transporter">
                            <Select
                              className="w-100"
                              showSearch
                              optionFilterProp="children"
                              options={transporterList?.map((item) => ({
                                label: item.Name,
                                value: item.ID,
                              }))}
                              filterOption={(input, option) =>
                                option?.label
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Consignee" name="consignee">
                            <Select
                              className="w-100"
                              showSearch
                              optionFilterProp="children"
                              options={consigneeList?.map((item) => ({
                                label: item.Name,
                                value: item.ID,
                              }))}
                              filterOption={(input, option) =>
                                option?.label
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Driver" name="driver">
                            <Select
                              className="w-100"
                              showSearch
                              optionFilterProp="children"
                              options={driverList?.map((item) => ({
                                label: item.FULLNM,
                                value: item.UID,
                              }))}
                              filterOption={(input, option) =>
                                option?.label
                                  ?.toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="Trip Type" name="tripType">
                            <Select
                              className="w-100"
                              showSearch
                              allowClear
                              // suffixIcon={<SearchOutlined className="search_icon" />}
                            >
                              <Option value={2}>Safari</Option>
                              <Option value={1}>Local</Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                          <Form.Item label="View Data by" name="SelectedOption">
                            <Radio.Group
                              onChange={(e) => {
                                setFormValues((prev) => ({
                                  ...prev,
                                  SelectedOption: e.target.value,
                                }));
                              }}
                            >
                              <Radio value="Driver">Drivers</Radio>
                              <Radio value="Vehicle">Vehicles</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </Modal>
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        <Spin spinning={loading}>
          <Row gutter={12}>
            <Col
              sm={24}
              md={24}
              style={{
                display: "flex",
                justifyContent: "space-around",
                textAlign: "center",
                backgroundColor: "#F4F4F4",
              }}
            >
              {VehicleDetailsData.map((item, index) => (
                <div key={index} className="vehicle-item">
                  <Stack direction="horizontal">
                    <div className="text-content">
                      <h6>{item.Name}</h6>
                      <h3>{item.values}</h3>
                      <p>{item.precentage_values}</p>
                    </div>
                    {index < 2 && <div className="vr" />}
                  </Stack>
                </div>
              ))}
            </Col>
            <Col sm={24} md={24}>
              <Spin spinning={loading}>
                <Card
                  title={`Total ${
                    formValues?.ReportType === 1 ? "Trips" : "Consignments"
                  } (${
                    formValues?.ReportType === 1
                      ? (chartData?.TotalTrips ?? 0)
                      : (chartData?.TotalConsignments ?? 0)
                  })`}
                  className="mt-3"
                  id="Total Consignment"
                  extra={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      {/* <Select
                        defaultValue="No Sorting"
                        className="rounded-pill"
                        style={{ width: 250 }}
                        onChange={handleConsignmentSelectChange}
                        options={[
                          { value: "High to Low", label: "High to Low" },
                          { value: "Low to High", label: "Low to High" },
                          { value: "No Sorting", label: "No Sorting" },
                        ]}
                      /> */}
                      <LeftOutlined
                        onClick={handleConsignmentPrev}
                        style={{
                          cursor:
                            consignmentPage > 0 ? "pointer" : "not-allowed",
                          color: consignmentPage > 0 ? "black" : "#ccc",
                        }}
                      />
                      <RightOutlined
                        onClick={handleConsignmentNext}
                        style={{
                          marginLeft: "15px",
                          cursor:
                            (consignmentPage + 1) * itemsPerPage <
                            (chartData?.TotalConsignmentChart?.length || 0)
                              ? "pointer"
                              : "not-allowed",
                          color:
                            (consignmentPage + 1) * itemsPerPage <
                            (chartData?.TotalConsignmentChart?.length || 0)
                              ? "black"
                              : "#ccc",
                        }}
                      />
                      <Button style={report.exportbtn}>
                        <img
                          src={ExportIcon}
                          alt="Export Icon"
                          width={20}
                          style={{
                            cursor: exportAllowed ? "pointer" : "not-allowed",
                          }}
                          onClick={() => {
                            if (!exportAllowed) return;
                            handleDownloadChart(
                              "Total Consignment",
                              `Total ${
                                formValues?.reportType === 1
                                  ? "Trips"
                                  : "Consignments"
                              }`,
                            );
                          }}
                        />
                      </Button>
                    </div>
                  }
                >
                  <TotalConsignment
                    data={getSortedConsignments()}
                    width="100%"
                    height={350}
                  />
                </Card>
              </Spin>
            </Col>
            <Col sm={24} md={24}>
              <br />
              <div id="VehiclesPerformanceChart">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                  }}
                >
                  {/* Heading */}
                  <h5>{`Vehicle's Performance per ${
                    formValues?.SelectedOption === "Driver"
                      ? "Driver"
                      : "Vehicle"
                  } `}</h5>
                </div>

                {/* Cards Container */}
                <div style={{ display: "flex", gap: "20px" }}>
                  {/* Most Utilized Card */}
                  <Col sm={24} md={12}>
                    <Spin spinning={loading}>
                      <div id="MostUtilized">
                        <Card
                          className="mt-3"
                          title={<h6>Most Utilized</h6>}
                          extra={
                            <Button style={report.exportbtn}>
                              <img
                                src={ExportIcon}
                                alt="Export Icon"
                                width={20}
                                style={{
                                  cursor: exportAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                onClick={() => {
                                  if (!exportAllowed) return;
                                  handleDownloadChart(
                                    "MostUtilized",
                                    "Most Utilized",
                                  );
                                }}
                              />
                            </Button>
                          }
                        >
                          <VerticalChart
                            data={chartData?.MostUtilized?.map((item) => {
                              return {
                                Vehicle_No: item?.Data,
                                Driver_Name: item?.Data,
                                value:
                                  formValues?.ReportType === 1
                                    ? item?.TripCount
                                    : item?.ConsignmentCount,
                              };
                            })}
                            width="100%"
                            height={380}
                            type={"Vehicle-No"}
                            barColor="#AC6DFF"
                            selectedOption={
                              formValues?.SelectedOption || "Vehicle"
                            }
                          />
                        </Card>
                      </div>
                    </Spin>
                  </Col>

                  {/* Least Utilized Card */}
                  <Col sm={24} md={12}>
                    <Spin spinning={loading}>
                      <div id="LeastUtilized">
                        <Card
                          className="mt-3"
                          title={<h6>Least Utilized</h6>}
                          extra={
                            <Button style={report.exportbtn}>
                              <img
                                src={ExportIcon}
                                alt="Export Icon"
                                width={20}
                                style={{
                                  cursor: exportAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                onClick={() => {
                                  if (!exportAllowed) return;
                                  handleDownloadChart(
                                    "LeastUtilized",
                                    "Least Utilized",
                                  );
                                }}
                              />
                            </Button>
                          }
                        >
                          <VerticalChart
                            data={chartData?.LeastUtilized?.map((item) => {
                              return {
                                Vehicle_No: item?.Data,
                                Driver_Name: item?.Data,
                                value:
                                  formValues?.ReportType === 1
                                    ? item?.TripCount
                                    : item?.ConsignmentCount,
                              };
                            })}
                            width="100%"
                            height={380}
                            barColor="#3C70AB"
                            selectedOption={
                              formValues?.SelectedOption || "Vehicle"
                            }
                          />
                        </Card>
                      </div>
                    </Spin>
                  </Col>
                </div>
              </div>
            </Col>
            <Col sm={24} md={24}>
              <Spin spinning={loading}>
                <div id="VehiclePerformanceData">
                  <Card className="mt-3 ">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "15px 0px",
                      }}
                    >
                      <h5>Vehicle Performance Data</h5>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <LeftOutlined
                          onClick={handlePrev}
                          style={{
                            cursor: currentPage > 0 ? "pointer" : "not-allowed",
                            color: currentPage > 0 ? "black" : "#ccc",
                          }}
                        />
                        <RightOutlined
                          onClick={handleNext}
                          style={{
                            marginLeft: "15px",
                            cursor:
                              (currentPage + 1) * itemsPerPage <
                              chartData?.VehiclePerformance?.length
                                ? "pointer"
                                : "not-allowed",
                            color:
                              (currentPage + 1) * itemsPerPage <
                              chartData?.VehiclePerformance?.length
                                ? "black"
                                : "#ccc",
                          }}
                        />
                        <Button style={report.exportbtn}>
                          <img
                            src={ExportIcon}
                            alt="Export Icon"
                            width={20}
                            style={{
                              cursor: exportAllowed ? "pointer" : "not-allowed",
                            }}
                            onClick={() => {
                              if (!exportAllowed) return;
                              handleDownloadChart(
                                "VehiclePerformanceData",
                                "Vehicle Performance Data",
                              );
                            }}
                          />
                        </Button>
                      </div>
                    </div>

                    <VRvehiclePerformance
                      // data={paginatedData}
                      data={(paginatedData || []).map((item) => ({
                        ...item,

                        Fuel: Number(item?.Fuel) || 0,
                        Distance: Number(item?.Distance) || 0,
                        Mileage: Number(item?.Mileage) || 0,
                      }))}
                      width="100%"
                      height={350}
                    />
                  </Card>
                </div>
              </Spin>
            </Col>
            <Col sm={24} md={24}>
              <Spin spinning={loading}>
                <div id="VehicleMileage">
                  <Card
                    title=" Vehicle Performance by Mileage (Km/L)"
                    className="mt-3"
                    extra={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        {/* Sorting Dropdown */}
                        {/* <Select
                          defaultValue="No Sorting"
                          className="rounded-pill"
                          style={{
                            width: 250,
                          }}
                          onChange={(value) =>
                            setVehiclePerformanceSelectChange(value)
                          }
                          options={[
                            {
                              value: "High to Low",
                              label: "High to Low",
                            },
                            {
                              value: "Low to High",
                              label: "Low to High",
                            },
                            {
                              value: "No Sorting",
                              label: "No Sorting",
                            },
                          ]}
                        /> */}

                        {/* Left and Right Icons */}
                        <LeftOutlined
                          onClick={handlePrevPage}
                          style={{
                            cursor: "pointer",
                            opacity: currentPage === 0 ? 0.5 : 1,
                          }}
                        />
                        <RightOutlined
                          onClick={handleNextPage}
                          style={{
                            marginLeft: "15px",
                            cursor: "pointer",
                            opacity:
                              currentPage >=
                              Math.floor(
                                (chartData?.Mileage?.length || 0) / pageSize,
                              )
                                ? 0.5
                                : 1,
                          }}
                        />

                        {/* Export Button */}
                        <Button style={report.exportbtn}>
                          <img
                            src={ExportIcon}
                            alt="Export Icon"
                            width={20}
                            style={{
                              cursor: exportAllowed ? "pointer" : "not-allowed",
                            }}
                            onClick={() => {
                              if (!exportAllowed) return;
                              handleDownloadChart(
                                "VehicleMileage",
                                "Vehicle Performance by Mileage",
                              );
                            }}
                          />
                        </Button>
                      </div>
                    }
                  >
                    <VehicleMileage
                      data={
                        vehiclePerformanceSelectChange === "No Sorting"
                          ? getPaginatedData().map((item) => ({
                              ...item,
                              ConsignmentCount:
                                Number(item?.ConsignmentCount) || 0,
                            }))
                          : vehiclePerformanceSelectChange === "Low to High"
                            ? [...chartData?.Mileage]
                                .sort(
                                  (a, b) =>
                                    (Number(a.ConsignmentCount) || 0) -
                                    (Number(b.ConsignmentCount) || 0),
                                )
                                .slice(
                                  currentPage * pageSize,
                                  (currentPage + 1) * pageSize,
                                )
                                .map((item) => ({
                                  ...item,
                                  ConsignmentCount:
                                    Number(item?.ConsignmentCount) || 0,
                                }))
                            : [...chartData?.Mileage]
                                .sort(
                                  (a, b) =>
                                    (Number(b.ConsignmentCount) || 0) -
                                    (Number(a.ConsignmentCount) || 0),
                                )
                                .slice(
                                  currentPage * pageSize,
                                  (currentPage + 1) * pageSize,
                                )
                                .map((item) => ({
                                  ...item,
                                  ConsignmentCount:
                                    Number(item?.ConsignmentCount) || 0,
                                }))
                      }
                    />
                  </Card>
                </div>
              </Spin>
            </Col>
            <div
              className="header"
              style={{
                margin: "24px 0 12px 0",
              }}
            >
              <span>{total || 0} Vehicles</span>

              <div className="export">
                <Spin spinning={CSVLoader}>
                  <img
                    src={ExportIcon}
                    alt="Export"
                    onClick={() => {
                      if (!exportAllowed) return;
                      prepareCSV();
                    }}
                    style={{
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                    }}
                  />
                </Spin>

                <CSVLink
                  data={CSVList && CSVList.length > 0 ? CSVList : []}
                  filename={"Vehicle Report.csv"}
                  asyncOnClick={true}
                  ref={csvLinkEl}
                />
              </div>
            </div>

            {TableData?.length > 0 && (
              <StyledTable
                dataSource={TableData}
                columns={columns1}
                pagination={false}
                style={{ width: "100%" }}
                onChange={(pagination, filters, sorter) => {
                  setTableSort({
                    field: sorter.field,
                    order: sorter.order,
                  });
                }}
              />
            )}
          </Row>
        </Spin>
        <ReusablePagination
          pageSize={PageSize}
          handlePageSizeChange={handlePageSizeChange}
          currentPage={currentPage1}
          total={total}
          handlePageChange={handlePageChange}
        />
      </StyledVehicleReport>
    </>
  );
};

export default Vehiclereport;
